'use strict';

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

require('babel-polyfill');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _create = require('./redux/create');

var _create2 = _interopRequireDefault(_create);

var _ApiClient = require('./helpers/ApiClient');

var _ApiClient2 = _interopRequireDefault(_ApiClient);

var _reactRedux = require('react-redux');

var _reactRouter = require('react-router');

var _reactRouterRedux = require('react-router-redux');

var _reduxConnect = require('redux-connect');

var _useScroll = require('react-router-scroll/lib/useScroll');

var _useScroll2 = _interopRequireDefault(_useScroll);

var _reactCookie = require('react-cookie');

var _routes = require('./routes');

var _routes2 = _interopRequireDefault(_routes);

var _reactI18next = require('react-i18next');

var _i18nUniversal = require('./i18n-universal');

var _i18nUniversal2 = _interopRequireDefault(_i18nUniversal);

var _reactReduxToastr = require('react-redux-toastr');

var _reactReduxToastr2 = _interopRequireDefault(_reactReduxToastr);

var _ProgressPopup = require('components/ProgressPopup/ProgressPopup');

var _ProgressPopup2 = _interopRequireDefault(_ProgressPopup);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * THIS IS THE ENTRY POINT FOR THE CLIENT, JUST LIKE server.js IS THE ENTRY POINT FOR THE SERVER.
 */
var client = new _ApiClient2.default();
var dest = document.getElementById('content');
var store = (0, _create2.default)(_reactRouter.browserHistory, client, window.__data);
var history = (0, _reactRouterRedux.syncHistoryWithStore)(_reactRouter.browserHistory, store);

var i18n = _i18nUniversal2.default.getI18n();

document.documentElement.className += 'ontouchstart' in document.documentElement ? ' touch' : ' no-touch';

var scrollBehavior = (0, _useScroll2.default)(function (prevRouterProps, _ref) {
  var routes = _ref.routes;

  if (routes.some(function (route) {
    return route.ignoreScrollBehavior;
  })) {
    return false;
  }

  if (routes.some(function (route) {
    return route.scrollToTop;
  })) {
    return [0, 0];
  }

  return true;
});

var component = _react2.default.createElement(
  _reactRouter.Router,
  {
    render: function render(props) {
      return _react2.default.createElement(_reduxConnect.ReduxAsyncConnect, (0, _extends3.default)({}, props, {
        helpers: { client: client },
        filter: function filter(item) {
          return !item.deferred;
        },
        render: (0, _reactRouter.applyRouterMiddleware)(scrollBehavior)
      }));
    },
    history: history
  },
  (0, _routes2.default)(store)
);

_reactDom2.default.render(_react2.default.createElement(
  _reactCookie.CookiesProvider,
  null,
  _react2.default.createElement(
    _reactI18next.I18nextProvider,
    { i18n: i18n },
    _react2.default.createElement(
      _reactRedux.Provider,
      { store: store, key: 'provider' },
      _react2.default.createElement(
        'div',
        null,
        component,
        _react2.default.createElement(
          'div',
          { className: 'toastr-container' },
          _react2.default.createElement(_reactReduxToastr2.default, { position: 'top-center' })
        ),
        _react2.default.createElement(_ProgressPopup2.default, null)
      )
    )
  )
), dest);

if (process.env.NODE_ENV !== 'production') {
  window.React = _react2.default; // enable debugger

  if (!dest || !dest.firstChild || !dest.firstChild.attributes || !dest.firstChild.attributes['data-react-checksum']) {
    console.error('Server-side React render was discarded. Make sure that your initial render does not contain any client-side code.');
  }
}

if (__DEVTOOLS__ && !window.devToolsExtension) {
  var DevTools = require('./containers/DevTools/DevTools');
  _reactDom2.default.render(_react2.default.createElement(
    _reactCookie.CookiesProvider,
    null,
    _react2.default.createElement(
      _reactI18next.I18nextProvider,
      { i18n: i18n },
      _react2.default.createElement(
        _reactRedux.Provider,
        { store: store, key: 'provider' },
        _react2.default.createElement(
          'div',
          null,
          component,
          _react2.default.createElement(
            'div',
            { className: 'toastr-container' },
            _react2.default.createElement(_reactReduxToastr2.default, { position: 'top-center' })
          ),
          _react2.default.createElement(_ProgressPopup2.default, null),
          _react2.default.createElement(DevTools, null)
        )
      )
    )
  ), dest);
}


//////////////////
// WEBPACK FOOTER
// ./src/client.js
// module id = 1937
// module chunks = 1